export default __webpack_public_path__ + "media/images/dashboard/home-147879d64595b3ab8b3f305b07605971.svg";